/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  createContext,
  useContext,
  cloneElement,
} from 'react';
import { css, jsx } from '@emotion/core';

export const FeedbackSubmittedEditable = props => {
  const { children } = props;
  const [img, txt] = children;

  // console.log(img);

  return (
    <div
      className="fader_-5s"
      css={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      `}
    >
      {img}
      <div
        css={css`
          margin: 25px 0 0 0;
          font-size: 18px;
          text-align: center;
        `}
        role="alert"
      >
        {txt}
      </div>
    </div>
  );
};
